import { getFontCss, styleConstants } from '@paywithextend/components'
import { css } from 'styled-components'

export const sideInfoPanel = css`
  border-radius: 0px 10px 10px 0px;
  max-width: 320px;
  background: linear-gradient(27deg, #4f3fdd 0.27%, #588af2 100.75%);
  box-shadow: 4px 0 8px 0 rgba(0, 0, 0, 0.15) inset;
`

export const sideInfoInner = css`
  margin: 120px 40px;
`

export const sideInfoTitle = css`
  ${getFontCss(
    20,
    styleConstants.colors.white,
    styleConstants.fontFamilies.medium,
  )};
  margin-bottom: 16px;
`

export const sideInfoList = css`
  ${getFontCss(
    14,
    styleConstants.colors.white,
    styleConstants.fontFamilies.regular,
  )};
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const sideInfoServiceRow = css`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: flex-start;
`

export const sideInfoServiceIcon = css`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: -2px;

  svg {
    width: 20px;
    height: 20px;
  }
`

export const sideInfoServiceText = css`
  max-width: 212px;
`

export const sideInfoDisclaimer = css`
  margin-top: 144px;
  font-size: 12px;
  font-style: italic;
  line-height: 16px;
`

export const stepEyebrow = css`
  ${getFontCss(
    12,
    styleConstants.colors.purple,
    styleConstants.fontFamilies.regular,
  )};
  margin-bottom: 20px;
`

export const formPane = css`
  flex-grow: 1;
  max-width: 660px;
  padding: 80px;
  display: flex;
  flex-direction: column;
`

export const fieldRow = css`
  display: flex;
  gap: 20px;

  > * {
    flex: 1;
  }
`

export const fieldGroup = css`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 28px;
`

export const dividerLine = css`
  height: 1px;
  background-color: #dadbe0;
  width: 100%;
  margin: 28px 0;
`

export const submitRow = css`
  display: flex;
  margin-top: 40px;
`

export const loadingContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 360px;
  width: 100%;
`

export const reviewPane = css`
  width: min(900px, calc(100vw - 40px));
  padding: 60px;
  box-sizing: border-box;
`

export const amexCardTypeBlock = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 28px;
`

export const amexCardTypeTitle = css`
  ${getFontCss(
    20,
    styleConstants.colors.gray_darkest,
    styleConstants.fontFamilies.medium,
  )};
`

export const amexCardTypeMicrocopy = css`
  ${getFontCss(
    12,
    styleConstants.colors.gray_darkest,
    styleConstants.fontFamilies.regular,
  )};
  margin-bottom: 12px;
`
